<template>
  <div class="white-container pricing-card">
    <div class="wallkit-pricing-card__content-wrapper">
      <div class="d-flex align-items-center justify-content-between pricing-badges-wrapper">
        <div>
          <b-badge
            :variant="item.active ? 'success': 'info'"
            class="text-white font-weight-normal pricing-badge"
          >
            {{ $t('global.active') }}
          </b-badge>
          <b-badge
            :variant="item.is_public ? 'success': 'info'"
            class="text-white ml-2 font-weight-normal pricing-badge"
          >
            {{ $t('form.public') }}
          </b-badge>
        </div>
        <b-button
          variant="outline-primary"
          style="height: 34px; width: 34px"
          class="ml-2 border-0 p-1"
          @click="onDelete"
        >
          <i class="far fa-trash-alt fa-lg" />
        </b-button>
      </div>
      <h4 class="text-center mb-3">
        {{ item.title }}
      </h4>
      <div style="align-items: baseline" class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.description') }}
        </h6>
        <span style="white-space: pre-wrap">{{ item.description }}</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.transaction_fee') }}
        </h6>
        <span>{{ item.transaction_fee }} %</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.monthly_fee') }}
        </h6>
        <span>{{ formatToDollars(item.monthly_price) }} USD</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.free_signups') }}
        </h6>
        <span>{{ item.free_signups }}</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.signups_included') }}
        </h6>
        <span>{{ item.up_free_signups }}</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.price_for_extra_signups') }}
        </h6>
        <span>{{ formatToDollars(item.up_free_signups_price) }} USD</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.free_support_hours') }}
        </h6>
        <span>{{ item.free_support_hours }}</span>
      </div>
      <div class="wallkit-pricing-card__value-row">
        <h6>
          {{ $t('wallkit_pricing.card.extra_support_hours') }}
        </h6>
        <span>{{ formatToDollars(item.up_free_support_price_per_hour) }} USD per hour</span>
      </div>
    </div>
    <div>
      <b-button class="px-4 my-4 w-100 edit-plan-button" variant="outline-primary" @click="onEdit">
        {{ $t('wallkit_pricing.card.edit') }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WallkitPlanCard',
  props: {
    id: {
      type: Number,
      default: null
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onDelete() {
      this.$emit('onDeletePlan', this.id);
    },
    onEdit() {
      this.$emit('onEditPlan', this.id);
    },
  },
};
</script>
